import {
  useGetMyDetails,
  useGetUserCommunities,
  useGetUserDetails,
  useGetUserSubscribers,
  useGetUserSubscriptions,
  useSubscribeToUser,
  useUnsubscribeFromUser,
} from '../../services/redux/api/usersApi';
import { useNotFound } from '../../hooks/useNotFound';
import { LoaderId, useShowLoader } from '../../hooks/useShowLoader';
import { useLazyLoadPosts } from '../../hooks/use-lazy-load-posts';
import { useLazyGetUserPosts } from '../../services/redux/api/postsApi';
import {
  RelationStatus,
  AccessScope,
  PostsInteractionScope,
} from '../../shared/constants';
import { all } from 'axios';

export function useUserPage(userId: string) {
  const { data: user } = useGetMyDetails();

  const { data: reviewedUser, isFetching: userLoading } = useGetUserDetails({
    id: userId,
  });
  const {
    data: reviewedUserSubscribers,
    isFetching: isFetchingUserSubscribers,
  } = useGetUserSubscribers(userId);
  const {
    data: reviewedUserSubscriptions,
    isFetching: isFetchingUserSubscriptions,
  } = useGetUserSubscriptions(userId);
  const { data: communities, isFetching: isFetchingCommunities } =
    useGetUserCommunities(userId);
  useNotFound(!userLoading && !reviewedUser);
  useShowLoader(
    LoaderId.homePage,
    userLoading,
    isFetchingCommunities,
    isFetchingUserSubscribers,
    isFetchingUserSubscriptions,
  );

  const isCurrentUser = user.id === userId;
  const subscriptionRelation = user?.subscriptions?.find(
    (s) => s.toUserId === userId,
  );
  const [subscribeToUser] = useSubscribeToUser();
  const [unsubscribeFromUser] = useUnsubscribeFromUser();
  const { items: posts, footerRef } = useLazyLoadPosts(
    useLazyGetUserPosts,
    userId,
  );

  function onSubscribe() {
    subscribeToUser({ id: reviewedUser?.id }).catch((e) => console.log(e));
  }

  function onUnsubscribe() {
    unsubscribeFromUser({ id: reviewedUser?.id }).catch((e) => console.log(e));
  }

  const isRelationPanel =
    reviewedUserSubscriptions?.length ||
    reviewedUserSubscribers?.length ||
    communities?.length;
  const isReviewPermission =
    reviewedUser?.accessConfig.scope === AccessScope.public ||
    subscriptionRelation?.status === RelationStatus.approved;
  const isAddPostPermissions =
    reviewedUser?.id === user?.id ||
    reviewedUser?.accessConfig.postsScope === PostsInteractionScope.all ||
    (reviewedUser?.accessConfig.postsScope ===
      PostsInteractionScope.subscribers &&
      subscriptionRelation?.status === RelationStatus.approved);
  const isAddCommentPermissions =
    reviewedUser?.id === user?.id ||
    reviewedUser?.accessConfig.commentsScope === PostsInteractionScope.all ||
    (reviewedUser?.accessConfig.commentsScope ===
      PostsInteractionScope.subscribers &&
      subscriptionRelation?.status === RelationStatus.approved);

  // function onSendMessageClick() {
  //   const chat = _.find(chats, (chat) => chat.idPrivate && _.find(chat.members, m => m.userId === reviewedUser.id)?.userId);
  //
  //   if (!chat) {
  //     const newChat = {
  //       isPrivate: true,
  //       members: [{ userId: reviewedUser.id, }, { userId: user.id, }]
  //     }
  //
  //     addChatApi({ body: newChat }).then(response => {
  //       navigate(`${Paths.chats}/${response.data.id}`);
  //     });
  //   } else {
  //     navigate(`${Paths.chats}/${chat.id}`);
  //   }
  // }

  return {
    isRelationPanel,
    isCurrentUser,
    subscriptionRelation,
    posts,
    reviewedUser,
    footerRef,
    reviewedUserSubscriptions,
    reviewedUserSubscribers,
    communities,
    userLoading,
    permissions: [
      isReviewPermission && 'view',
      isAddPostPermissions && 'post',
      isAddCommentPermissions && 'comment',
    ],
    onSubscribe,
    onUnsubscribe,
  };
}
